export default "__VITE_ASSET__a4dc5d7d__"